import React from 'react'

function Error() {
  return (
    <div className='error404'>
        
        <img src="" alt="" />
        
    </div>
  )
}

export default Error